export default __webpack_public_path__ + "static/desktop-1ed1792d0ba085b43f308a8270ff519f.svg";